import React from "react";
import { inject, observer } from "mobx-react";
import { Message, useMessageGetter } from "react-message-context";
import { Button, ButtonRow } from "@op/opds.opux";
import { Modal } from "@op/opds.opux-modal";

const ContinueSessionModal = observer(({ SessionStore }) => {
  const { showContinueSessionModal } = SessionStore;

  const msgs = useMessageGetter("session.continue.modal");

  const handleOnContinue = () => {
    SessionStore.continueSession();
  };

  const handleOnEnd = () => {
    SessionStore.endSession();
  };

  const createFooter = () => (
    <ButtonRow className="rof-modal__footer">
      <Button id="ROF-continueSession-cancel" compact onClick={handleOnEnd}>
        {msgs("cancel")}
      </Button>
      <Button
        id="ROF-continueSession-continue"
        compact
        onClick={handleOnContinue}
      >
        {msgs("ok")}
      </Button>
    </ButtonRow>
  );

  return (
    <Modal
      id="ROF-continueSession"
      footer={createFooter()}
      isOpen={showContinueSessionModal}
      onUpdate={(state) => {
        SessionStore.showContinueSessionModal = state.open;
      }}
      title={msgs("title")}
      appElement={document.getElementById("reportproblemopfi-main")}
    >
      <div className="opux-v6__opds">
        <p>
          <Message id="session.continue.modal.text" />
        </p>
      </div>
    </Modal>
  );
});

export default inject("SessionStore")(ContinueSessionModal);
